import { getDriverTrainingEnum } from '@/api/driver-training-manage/course-manage'

const state = {
	driverTrainingEnum: null
}

const mutations = {
	DRIVER_TRAINING_ENUM: (state, payload) => {
		state.driverTrainingEnum = payload
	}
}

const actions = {
	async getDriverTrainingEnumInfo({ commit, state }) {
		if (state.driverTrainingEnum) return
		try {
			const { data = {}, code } = await getDriverTrainingEnum()
			if (data) {
				commit('DRIVER_TRAINING_ENUM', data)
			}
		} catch (error) {
			console.log(error)
			commit('DRIVER_TRAINING_ENUM', error.data)
		}
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
